import { store } from "../pinia/store";
import {
  useTimeoutFn,
  useIntervalFn,
  useDebounceFn,
  useThrottleFn,
} from "@vueuse/core";
import {
  showToast as vantShowToast,
  closeToast,
  ToastType,
  NotifyType,
} from "vant";
import { showDialog as vantShowDialog } from "vant";
import { showNotify as vantuseShowNotify } from "vant";
import "vant/es/toast/style";
import "vant/es/dialog/style";
import "vant/es/notify/style";
import "vant/es/image-preview/style";
import { utilGoBack } from "@/utils";
import debounce from "lodash/debounce";

const useShowToast = (
  message: string,
  type: ToastType = "text",
  duration = 2500
) => {
  vantShowToast({ type, message, duration, forbidClick: false });
};
const useHideToast = () => {
  closeToast();
};
const useShowNotify = (message: string, type: NotifyType = "success") => {
  //type:success,danger
  if (message) {
    vantuseShowNotify({ type, message });
  }
};
let loadingTimer;
// 自定义loading弹窗
const useShowLoading = () => {
  clearTimeout(loadingTimer);
  const appDataStore = store();
  appDataStore.isShowLoading = true;
  loadingTimer = setTimeout(() => {
    if (appDataStore.isShowLoading) {
      appDataStore.isShowLoading = false;
      console.log("强制消失");
      clearTimeout(loadingTimer);
    }
  }, 5000);
};
const useHideLoading = () => {
  const appDataStore = store();
  appDataStore.isShowLoading = false;
  clearTimeout(loadingTimer);
};

const useShowAlert = (
  message = "",
  title = "温馨提示",
  confirmButtonText = "确认",
  confirmButtonColor = '#FF5000',
  className = ''
) => {
  return new Promise((resolve) => {
    vantShowDialog({
      title,
      message,
      confirmButtonText,
      confirmButtonColor,
      className
    }).then(() => {
      resolve(true);
    });
  });
};

const useShowConfirm = (
  message = "",
  title = "温馨提示",
  confirmButtonText = "确认",
  cancelButtonText = "取消",
  confirmButtonColor = "#FF5000"
) => {
  return new Promise((resolve) => {
    vantShowDialog({
      title,
      message,
      confirmButtonText,
      cancelButtonText,
      showCancelButton: true,
      confirmButtonColor,
    })
      .then(() => {
        resolve(true);
      })
      .catch(() => {
        resolve(false);
      });
  });
};

const useGlobalSetTimeout = (fn: () => void, time = 1000) => {
  useTimeoutFn(fn, time);
};

const useGlobalSetInterval = (fn: () => void, time = 1000) => {
  useIntervalFn(fn, time);
};

// 节流函数，可用于放重复点击
const useGlobalThrottle = (callback: (anyParams: any) => void, time = 3000) =>
  useThrottleFn((anyParams) => {
    callback(anyParams);
  }, time);

// 防抖函数，
const useGlobalDebounce = (callback: () => void, time = 1000, maxWait = 5000) =>
  useDebounceFn(
    () => {
      callback();
    },
    time,
    { maxWait }
  );

const useLodashDebounce = (callback, time = 1000, maxWait = 5000) =>
    debounce(callback, time, { maxWait, leading: true, trailing: false });

const useSetTimeout = (fn: () => {}, time = 1000) => {
  useTimeoutFn(fn, time);
};

/**
 * @description: 更新成功后，跳alert提示框，点击确定，固定时间后 回到上一页
 * @param {string} text
 * @return {*}
 */
const useShowSuccessAlert = async (text: string) => {
  if (await useShowAlert(text)) {
    useGlobalSetTimeout(() => {
      utilGoBack();
    }, 300);
  }
};

export {
  useShowSuccessAlert,
  useGlobalThrottle,
  useGlobalDebounce,
  useShowToast,
  useHideToast,
  useShowLoading,
  useHideLoading,
  useShowNotify,
  useShowAlert,
  useShowConfirm,
  useGlobalSetTimeout,
  useGlobalSetInterval,
  useSetTimeout,
  useLodashDebounce
};
